import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';
import { Bogle_Medium, Bogle_Light } from 'constants/constant';
import { colors } from 'theme/color-palette';

const { BLUE_ACTIVE } = colors;

const styles = {
	'@global': {
		'.MuiTable-root': {
			maxHeight: (props) => `${props.height}px !important`
		},
		'.MuiTableSortLabel-root:focus': {
			color: BLUE_ACTIVE
		}
	},
	root: {
		height: (props) => `${props.height}px`,
		fontSize: (props) => `${props.fontSize}px`,
		fontFamily: (props) => (props.downloadCount === 0 ? Bogle_Medium : Bogle_Light),
		border: `unset`,
		maxWidth: (props) => `${props.width}px`,
		textOverflow: 'ellipsis'
	},
	'&:root:focus': {
		color: 'grey'
	}
};

function MyTableCellRaw(props) {
	// eslint-disable-next-line no-unused-vars
	const { classes, height, width, fontSize, downloadCount, ...other } = props;
	return (
		<TableCell
			height={height}
			fontSize={fontSize}
			width={width}
			className={classes.root}
			{...other}
			tabIndex="0"
		/>
	);
}

MyTableCellRaw.propTypes = {
	/**
	 * Override or extend the styles applied to the component.
	 */
	classes: PropTypes.object.isRequired,
	height: PropTypes.number,
	width: PropTypes.number,
	fontSize: PropTypes.number,
	downloadCount: PropTypes.number
};

const MyTableCell = withStyles(styles)(MyTableCellRaw);

export default function MyTableCellHOC(props) {
	const { fontSize, width, height, downloadCount = 0, ...other } = props;
	return (
		<MyTableCell
			fontSize={fontSize}
			width={width}
			height={height}
			downloadCount={downloadCount}
			{...other}
		/>
	);
}
